import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.facebook.post,
    props.user.facebook.tasks,
    props.user.facebook.active_bonus_time,
    props.user.facebook.uncompleted_rewards,
    props.user.facebook.button,
    (post, tasks, active_bonus_time, uncompleted_rewards, button) => {
        return {
            post,
            tasks,
            active_bonus_time,
            uncompleted_rewards,
            button
        }
    }
)